import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';

function RefundPolicy() {
  const navigate = useNavigate();

  return (
    <div className="home-wrapper">
      {/* HEADER */}
      <header className="modern-header">
        <div className="container header-flex">
          <div className="brand-box flex-center">
            <img src="/logo.svg" alt="Logo" className="nav-logo" onError={(e) => e.target.style.display='none'} />
          </div>
          <div className="desktop-nav">
            <nav className="nav-links">
              <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }}>Home</a>
            </nav>
            <div className="nav-actions">
                <button className="btn-primary" onClick={() => navigate('/login')}>Login</button>
            </div>
          </div>
          
          {/* Simple Mobile Back Button */}
          <button className="mobile-menu-btn" onClick={() => navigate('/')}>
            🔙
          </button>
        </div>
      </header>

      {/* MAIN CONTENT */}
      <main className="section-padding bg-surface" style={{ minHeight: '80vh' }}>
        <div className="container">
          <div className="card-editorial border-left-highlight" style={{ padding: '3rem' }}>
            <div className="flex-center-left gap-4 mb-8">
              <div className="icon-box-primary">📄</div>
              <h1 className="section-title-large" style={{ margin: 0 }}>Refund Policy</h1>
            </div>

            <div className="policy-content" style={{ color: 'var(--on-surface-variant)', lineHeight: '1.8' }}>
              <p className="mb-8">
                Housefed Colony is a cooperative housing society. Our platform facilitates two primary functions: the collection of society dues and the management of our e-tendering system. Please review our payment and refund policies below.
              </p>

              <h3 className="section-title" style={{ fontSize: '1.25rem', marginBottom: '1rem', color: 'var(--on-surface)' }}>
                1. Member Payments (Maintenance, Service, Water & Sewage)
              </h3>
              <p className="mb-4">
                Payments made by members for monthly and yearly maintenance, service charges, water, and sewage fees are mandatory and non-optional. These payments can be made either online through our portal or offline at the society office.
              </p>
              <p className="mb-8">
                Because these are mandatory dues, <strong>there is no standard refund policy</strong>. However, in the event of an erroneous or excess payment, the Secretary or President of the society will be liable to authorize a refund or account adjustment. This authorized refund/adjustment will be processed either online or offline through the office.
              </p>

              <h3 className="section-title" style={{ fontSize: '1.25rem', marginBottom: '1rem', color: 'var(--on-surface)' }}>
                2. E-Tendering System (Advance Payments)
              </h3>
              <p className="mb-8">
                Participation in the e-tendering system requires an advance payment. For individuals or agencies who are not awarded the tender, refunds will be processed <strong>strictly through offline modes via the society office</strong>. There is no provision on the website or app to process e-tendering refunds online.
              </p>

              <h3 className="section-title" style={{ fontSize: '1.25rem', marginBottom: '1rem', color: 'var(--on-surface)' }}>
                3. Future Payments & Governing Rules
              </h3>
              <p className="mb-4">
                For any future payments introduced via the website, all refund decisions will be determined by the Secretary and President. These refunds will primarily be processed offline (at the office), though online methods may be utilized at the discretion of the management. The final decision rests entirely with the President and the Society.
              </p>
              <p className="mb-8">
                The Society strictly adheres to the rules and regulations laid out by the Punjab State Cooperative Department, specifically governed by <strong>The Punjab Cooperative Societies Act, 1961</strong>, and the rules framed thereunder.
              </p>

              <div className="bg-surface-low" style={{ padding: '1.5rem', borderRadius: '1rem', marginTop: '2rem' }}>
                <h4 style={{ margin: '0 0 0.5rem 0', color: 'var(--on-surface)' }}>Have a query?</h4>
                <p style={{ margin: 0 }}>For any queries or assistance regarding transactions, please contact the Housefed Colony office directly.</p>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* FOOTER */}
      <footer className="modern-site-footer">
        <div className="container footer-bottom" style={{ borderTop: 'none', padding: '2rem' }}>
          <p>© 2024 Housefed Colony Bathinda. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default RefundPolicy;